// risk
const es_in_risks_page = {
  address: 'Dirección',
  type: 'Tipo',
};
// Main-page
const es = {
  deposit: 'Depósito',
  Deposit: 'Depósito',
  withdraw: 'Retiro',
  Withdraw: 'Retiro',
  swap: 'Swap',
  Swap: 'Intercambio',
  pool: 'Pool',
  Pool: 'Pool',
  pools: 'Pools',
  Pools: 'Pools',
  view_pools: 'Ver Pools',
  view_pool: 'Ver Pool',
  add_token: 'Añadir Token',
  create_new_pool: 'Crear un nuevo pool',
  Create_New_Pool: 'Crear un nuevo Pool',
  your_liquidity: 'Tu Liquidez',
  Your_Liquidity: 'Tu Liquidez',
  farms: 'Farms',
  Farms: 'Farms',
  docs: 'Docs',
  account: 'Cuenta',
  Discord: 'Discord',
  Telegram: 'Telegram',
  Twitter: 'Twitter',
  connect_to_near: 'Conectarse a NEAR',
  slippage: 'Tolerancia al deslizamiento',
  minimum_received: 'Mínimo recibido',
  swap_rate: 'Tasa de intercambio',
  pool_fee: 'Pago por Pool',
  balance: 'Balance',
  from: 'Desde',
  to: 'para',
  submit: 'Enviar',
  view_account: 'Ver tu cuenta',
  liquidity: 'Liquidez',
  tokens: 'Tokens',
  fee: 'Tarifa',
  fees: 'Tarifas',
  details: 'Detalles',
  detail: 'Detalle',
  minimum_tokens_out: 'Mínimo recibido',
  pair: 'Par',
  tvl: 'TVL',
  add_liquidity: 'Añadir Liquidez',
  remove_liquidity: 'Remover Liquidez',
  total_liquidity: 'Total de  liquidez',
  my_shares: 'Acciones',
  token: 'Token',
  enter_token_address: 'Ingrese la dirección del token',
  remove: 'Retirar',
  select: 'Seleccionar',
  select_token: 'Seleccionar el Token',
  total_fee: '% total de la tarifa ',
  start_at: 'Empezó a las',
  end_at: 'Termina en',
  ended: 'Terminada',
  pending: 'Pendiente',
  rewards_per_week: 'Recompensas por semana',
  apr: 'APR',
  total_staked: 'Total staked',
  unclaimed_rewards: 'Recompensas no cobradas',
  claim: 'Cobradas',
  claim_all: 'Cobrado todo',
  stake: 'Stake',
  unstake: 'Unstake',
  your_shares: 'Acciones',
  cancel: 'Cancelar',
  days: 'dias',
  slippageCopyForMobile:
    'Deslizamiento (Slippage) significa la diferencia entre lo que espera obtener y lo que realmente obtiene es debido a que otros ejecutan primero',
  slippageCopy:
    'Deslizamiento (Slippage) significa la diferencia entre lo que espera obtener y lo que realmente obtiene debido a que otros ejecutan primero',
  swapCopy:
    'Swap intercambia el primer token seleccionado con el segundo <br> token seleccionado. Se utilizarán los Pools con la liquidez más alta disponible y la tarifa de intercambio más baja',
  addTokenCopy: 'Añade cualquier NEP-141 token',
  farmRewardsCopy: 'Valor indicativo basado en precios y no en ejecución real',
  you_do_not_have_enough: 'no tienes suficientes fondos',
  is_not_exist: 'no existe',
  must_input_a_value_greater_than_zero: 'Must input a value greater than 0',
  no_pool_available_to_make_a_swap_from:
    'No hay Pool disponible para hacer un intercambio',
  for_the_amount: 'Por la cantidad',
  no_pool_eng_for_chinese: ' ',
  is_not_a_valid_swap_amount: 'No es un monto válido para hacer Swap',
  not_nep_address:
    'La dirección que ingresó no es una dirección NEP-141, verifíquela e ingrésela nuevamente. Si se trata de otro contrato en red principal (mainnet), vaya a Rainbow Bridge para el procesamiento de puente',
  not_correct_address:
    'La dirección que ingresó es incorrecta, verifique e ingrese',
  pool_id: 'Pool ID',
  more_pools: 'Más pools',
  my_watchlist: 'Mi lista de interés a revisar',
  h24_volume: '24h volumen',
  volume: 'Volumen',
  hide_low_tvl_pools: 'Ocultar Pools de TVL bajos,',
  hide_low_tvl_pools_mobile: 'Ocultar TVL bajos',
  my_watchlist_copy: 'Las Pools seleccionadas aparecerán aquí',
  language: 'Idioma',
  deposit_to_add_liquidity: 'Depositar para agregar Liquidez',
  slip_warn: 'Tenga cuidado, por favor marque el mínimo que puede recibir',
  slip_invalid: 'La tolerancia de deslizamiento (slippage) no es válida',
  reward_tokens: 'Recompensa de tokens',
  detail_tip: 'Detalle',
  no_data: 'No hay Data',
  attention: 'Atención',
  live: 'En vivo',
  ended_search: 'Terminada',
  my_farms: 'Tus Farms',
  sort_by: 'Ordenada por ',
  your_farms: 'Tus farms',
  new: 'Más reciente',
  unstake_tip_t: 'tienes recompensas sin reclamar....',
  unstake_tip_m:
    'Unstaking eliminará la participación en todas las farms activas y pendientes del mismo par.',
  unstake_tip_b: '¿Quieres dejar de participar (unstake)?',
  value_rewards: 'Reclamar las recompensas',
  stake_unstake_tip:
    'Staking o Unstaking eliminará la participación de todas las farms activas y pendientes del mismo par.',
  over_tip:
    'Para optimizar la tarifa de gas, puede retirar hasta 4 tokens a la vez',
  no_token_tip: 'Sin token de recompensa',
  getToken_tip:
    '¡Puede reclamar sus recompensas o apostar sus tokens LP ahora!',
  in_farm: 'en Farm',
  price_impact: 'Impacto en el Precio',
  roi_calculator: 'Calculadora ROI ',
  lp_staked: 'LP Tokens Staked',
  usd: 'USD',
  lp_token: 'LP Tokens',
  stake_for: 'Duración',
  day_1: '1D',
  day_2: '7D',
  day_3: '30D',
  day_4: '90D',
  cur_apr: 'ROI',
  reward_token: 'Recompensa de tokens',
  get_lp_token: 'Aduiere LP Tokens',
  calculate_roi: 'Calculadora ROI',
  rewards_claimed: 'Recompensas reclamadas',
  value_rewards_token: 'Valor de las recompensas',
  all: 'Todo',
  all_5: 'Maximo 4 tokens a la vez',
  more_than: 'Ingrese un número mayor o igual a 0.01',
  less_than: 'Por favor ingrese un número menor a 20',
  no_valid: 'Por favor ingrese un número válido',
  lp_fee: 'Tarifa del LP',
  referral_fee: 'Tarifa de referencia',
  protocol_fee_referral_fee: 'Tarifa de protocolo y tarifa de referencia',
  total_fee_create: 'Total de las tarifas',
  ref: 'REF',
  are_you_sure: 'Está usted seguro?',
  price_impact_is_about: 'El impacto en el  precio se trata de',
  yes_swap: 'Sí, swap',
  input_greater_than_available_shares:
    'Entrada mayor que las acciones disponibles',
  auto_router: 'Enrutador automático',
  optimal_path_found_by_our_solution:
    'Ruta óptima encontrada por nuestra solución',
  make_sure_you_understand_what_you_do: 'Asegúrate de entender lo que haces',
  filter_by: 'Filtrar por',
  allOption: 'Todo',
  stablecoin: 'Stable',
  near_ecosystem: 'Near-eco',
  bridged_tokens: 'Bridged',
  gaming: 'Gaming',
  nft: 'NFT',
  bridge: 'Bridge to/from',
  no_result: 'Lo sentimos, no pudimos encontrar ninguna farm',
  multiple: 'Múltiple',
  default: 'Por defecto',
  create: 'Crear',
  select_a: 'Seleccione un',
  wallet: 'wallet',
  to_use_ref_finance: 'usar {appName}',
  not_supported: 'no suportado',
  installed: 'instalado',
  installe_now: 'instalar ahora',
  extension: 'extensión',
  first_time_using_ref: 'Primera vez usando {appName}',
  learn_more: 'Aprenda más',
  install_sender_now: 'Instalar remitente ahora',
  connect_to_dapps_with_one_click: 'Conéctese a un dApps con un clic',
  install: 'instalar',
  Connecting: 'Conectando',
  check_sender_wallet_extension:
    'Verifique la extensión de la billetera del remitente',
  having_trouble: 'Tienes algún problema?',
  go_back: 'Regresa',
  web: 'web',
  Type: 'Tipo',
  click_to_view: 'Click para ver',
  transaction_failed: 'Transacción fallida',
  wallet_vi: ' ',
  value: 'Valor',
  usd_value: 'Valor USD',
  initialize_account_tip: 'Inicializa tu cuenta.',
  support_ledger_tip:
    "Por diseño, Ledger no puede manejar grandes transacciones (i.e. Auto Router: operar en varias pools a la vez) debido a su limitación de memoria. Cuando está activada, la opción 'Support Ledger' limitará las transacciones a su forma más simple (en detrimento de los precios óptimos potenciales encontrados por nuestro enrutador automático), por lo que se pueden firmar transacciones de un tamaño razonable..",
  start: 'Empezar',
  max: 'Máximo',
  ref_account_balance_tip:
    'Parece que ocurrió un error al agregar/quitar liquidez al pool',
  ref_account_tip_2: 'Tienes token(s) en tu cuenta REF',
  ref_account_tip_top:
    'Tu(s) token(s) puede estar ahora en su cuenta interna REF',
  click_here: 'Dar Click aquí',
  to_recover_them: 'Para recuperarlos',
  ref_account_tip_3:
    'Para retirar tokens de su cuenta REF a su billetera NEAR, seleccione y retire',
  aurora_account_tip_4:
    'Para retirar tokens de su Mapping Account a su billetera NEAR, seleccione y retire',
  buy: 'Buy',
  sell: 'Sell',
  rate: 'Tarifa',
  name: 'Nombre',
  diff: 'Diff',
  best: 'Mejor',
  awesomeNear_verified_token: 'AwesomeNear Token verificado',
  pool_fee_apr: 'Tarifa del Pool por APY',
  ref_account_balance_tip_mobile: 'Tiene tokens en su cuenta REF.',
  click: 'Dar Click',
  to_recover: 'para recuperar.',
  rewards_week: 'Recompensas/semana',
  rewards: 'Recompensas',
  claimed_Rewards: 'Recompensas reclamadas',
  POOL: 'POOL',
  lp_Token: 'LP Tokens',
  booster: 'Booster',
  append: 'Añadir (Adjuntar)',
  farm: 'Farm',
  status: 'Status',
  Rewards: 'Recompensas',
  free: 'Gratuito',
  lp_tokens: 'LP tokens',
  connect_to_wallet: 'Conectarse a la Wallet',
  slash_policy_content:
    'Cada seed tiene su propia slash rate. Y disminuirá linealmente con el tiempo hasta que sea 0 en el momento de desbloqueo de esta cuenta de CD.',
  not_expired: 'no caducado',
  accept_pay_slash_tip: 'Acepto pagar el slash',
  i_will_pay: 'Yo pagaré',
  lp_token_slash: 'Tarifa de salida del token LP.',
  expired: 'Caducado',
  all_4_v2: '4 tokens/tiempo',
  more_than_seed: 'La entrada debe ser mayor o igual que ',
  how_to_earn_more: 'Cómo combinar las recompensas?',
  lock_your_lp_tokens_with_booster:
    'Bloquea tus LP tokens para que puedas hacer un boost a tus recompensas',
  unstaked_anytime_no_booster:
    'En cualquier momento puedes hacer Unstaked, no se realiza el  booster',
  locking_stake: 'Mantener el staking',
  change_to_lock: 'Cambiar para mantener el staking',
  estimated_rewards: 'Recompensas estimadas',
  final_booster: 'Booster Final',
  existing_amount: 'Cantidad exitente',
  append_amount: 'Anexar cantidad',
  will_be_able_to_unstaked_after:
    'estará disponible para después hacer el unstaked',
  you_have: 'Tú tienes',
  reward_apr: 'Recompensa por APR',
  stake_min_deposit: 'La entrada debe ser mayor o igual que ',
  unlock: 'Unlock',
  exit_fee: 'Tarifa por salir',
  end_locking_period: 'Fin del peródo de bloqueo',
  add_lp_tokens_tip:
    'Necesita tokens LP para hacer el pool en el farm  correspondiente. Primero agregue liquidez al pool para obtener tokens LP.',
  slash_tip:
    'Tarifa de salida = Tasa de tarifa de salida * Fin del período de bloqueo * Cantidad a desbloqueo',
  nonBoosted: 'No-boosted',
  exit_fee_tip:
    'Cantidad estimada que pagaría para romper su período de bloqueo',
  forbiddenTip: 'Este farm no admite esta opción de duración',
  unstakeTip:
    'Hacer Staking o unstaking automáticamente reclamará sus recompensas.',
  endedFarmsUnstakeTip:
    'Hacer Unstaking eliminará la participación de todas las farms activas y pendientes del mismo par. ',
  comimg: 'Próximamente',
  appendTip: 'No puede ser anterior a la hora de bloqueo actual',
  week: 'semana',
  yours: 'Suyos',
  boost: 'Boost',
  near: 'NEAR',
  eth: 'ETH',
  others: 'otros',
  stakeLove: 'Stake LOVE',
  unstakeLove: 'Unstake LOVE',
  get_love: 'Obtén LOVE',
  swap_successful: 'Swap realizado con éxito. ',
  trading_successfull: 'Intercambio exitoso. ',
  available_to_stake: 'disponible para hacer  stake',
  your_assets: 'Tus activos',
  connect_wallet: 'Conectarse a la Wallet',
  disconnect: 'Desconectar',
  change: 'Cambiar',
  connect: 'Conectar',
  veTip:
    'Los veLP tokens no son transferibles, los veLPT representan su poder de voto ',
  loveTip:
    'LOVE significa Liquidez de veToken. LOVE, como cualquier token NEP-141, es transferible y se puede intercambiar, agrupar, hacer pool y farm. LOVE representa la liquidez subyacente de sus veTokens',
  keep_ve: 'mantener',
  months: 'meses',
  month: 'mes',
  lock_lp_tokens: 'Bloquear LP Tokens',
  get_lptoken: 'Get LP Tokens',
  duration: 'Duration',
  ve_lock_tip: 'No puede ser anterior a la fecha de desbloqueo actual',
  get: 'Obtener',
  you_have_no_lp_share: 'No tienes LP Tokens',
  lock: 'Bloquear',
  locked: 'Bloqueado',
  available: 'Disponible',
  in: 'en',
  filter: 'Filtro',
  options: 'opciones',
  ratio: 'Relación',
  back: 'Regresar',
  confirm: 'Confirme',
  total: 'Total',
  type: 'Tipo',
  connect_to_near_wallet: 'Conectar a la Wallet de NEAR ',
  v1Legacy: 'Legacy',
  v2New: 'Classic-New',
  v2_new_farms: 'Classic farms update',
  migrate_now: 'Migrar ahora!',
  v2_boost_tip:
    'Las farms Classic admitirán boosted farms. Las farms Legacy se quedarán sin recompensas el <span class="font-bold">1 de agosto de 2022</span>.',
  v2_boost_no_tip:
    'Las farms Legacy se quedarán sin recompensas el <span class="font-bold">1 de agosto de 2022</span>..',
  love: 'LOVE',
  Available_to_stake: 'Disponibe para hacer stake',
  you_staked: 'Ha hecho un stake',
  has_rewards_tip_in_v2:
    'Retire las recompensas heredadas de <a rel="noopener noreferrer nofollow"  href="/farms" class="text-sm text-greenColor cursor-pointer underline ml-1 hover:text-senderHot"> Legacy Farms</a>.',
  how_to_get: 'Cómo obtener?',
  get_booster: 'Obtener Booster',
  ended_farms: 'Farms finalizadas',
  boosted_farms: 'Boosted farms',
  your_farm: 'Tus farm',
  your_boosted_farms: 'Tus boosted farms',
  search_farms_by_token: 'Buscar farms por token',
  search_farms: 'Buscar farms',
  more_lock_ve_popup2: 'más',
  left: 'dejado (left)',
  create_pool: 'Crear un Pool',
  search_by_token: 'Buscar por token',
  your_power: 'Tu Power',
  farm_has_boost_tip:
    'Tu Power = Tud staked LP Tokens * booster (por staking LOVE)',
  farm_no_boost_tip: 'Tu Power = Tu staked LP Tokens',
  more_than_a_simple_pool: 'Más que una simple pool',
  ended_Farms: 'Farms finalizadas ',
  vote_capital: 'VOTAR',
  boostFarmTip: 'Obtener booster haciendo staking en LOVE',
  boosted: 'Boosted',
  love_staked: 'Staked LOVE',
  your_apr: 'Tu APR',
  range_apr: 'Rango o referencia APR',
  no_pair_found: 'No se encontró ningún par',
  found_stable_pool_in_sauce: 'Pool stable pool en SAUCE',
  lp_tokens_locking: ' LP Tokens ',
  you_currently_have: 'Tu Actualmente tienes ',
  scheduled_to_be_unlocked: 'Programado para ser desbloqueado',
  locking_more_lp_tokens: 'Bloquear más LP Tokens ',
  will_mean_these: 'significará esto ',
  lp_tokens_will_not_be_unlocked_until:
    ' Los tokens LP no se desbloquearán hasta',
  "I_understand_that_I_won't_be_able_to_remove_my":
    "I understand that I won't be able to remove my ",
  until: 'hasta que',
  add: 'Aãdir',
  finish: 'Finalizar',
  add_custom_network: 'Agregar red personalizada',
  network_name: 'Nombre de red',
  rpc_name_taken_tip: 'El nombre de la red ya estaba tomado',
  network_invalid: 'La red no era válida',
  fobidden_testnet_rpc_tip:
    'La red del servidor RPC (testnet) es diferente con esta red (mainnet)',
  no_support_testnet_rpc_tip: 'Testnet no admite agregar una RPC personalizado',
  stable: 'Stable',
  limit: 'Limite',
  your_active_orders_will_appear_here: 'Sus pedidos activos apareceran aqui',
  your_history_orders_will_appear_here:
    'Sus historial de ordenes apareceran aqui',
  farm_only: 'Solamnte Farm',
  please_confirm_this_transaction_on_ledger:
    'Confirme esta transacción en Ledger',
  limit_order: 'Orden de limite',
  farm_stop_tip: 'Esta granja ha sido detenida.',
  pool_stop_tip: 'Este pool ha sido detenido.',
  volume_24h: 'Volume (24h)',
  add_to_watchlist: 'Anadir a la lista de vigilancia',
  remove_from_watchlist: 'Eliminar de la lista de vigilancia',
  create_order: 'Crear orden',
  filled: 'Llenado',
  canceled: 'Cancelado',
  partially_filled: 'Parcialmente lleno',
  pool_composition: 'Composicion del grupo',
  amount: 'Importe',
  h24_volume_bracket: 'Volume(24h)',
  fee_24h: 'Tasa(24h)',
  orders: 'Ordenes',
  your_orders: 'Tus ordenes',
  active: 'Activo',
  history: 'Historia',
  you_sell: 'Tu venta',
  you_buy: 'Tu compra',
  fee_tiers: 'Niveles de tarifas',
  created: 'Creado',
  executed: 'Ejecutado',
  actions: 'Acciones',
  claimed_upper: 'Reclamado',
  open_my_order: 'abierto',
  initial_order: 'Orden inicial',
  this_order_has_been_partially_filled:
    'Este pedido ha sido parcialmente ejecutado',
  filled_via_swap: 'Llenado a traves de un intercambio',
  state: 'Estado',
  partially: 'Parcialmente',
  near_validation_error: 'Must have 0.5N or more left in wallet for gas fee.',
  near_min_validation_error:
    'Must have 0.2N or more left in wallet for gas fee.',
  no_positons_in_this_pool_yet: 'No positons in this pool yet',
  no_claimed_rewards_yet: 'Recompensas por reclamar',
  out_of: 'de',
  fee_Tiers: 'Niveles de tasas',
  no_pool: 'No hay pool',
  input_amount: 'Introduzca el importe',
  update_range: 'Actualizar Rango',
  not_enough_balance: 'Saldo insuficiente',
  set_price_range: 'Establecer rango de precios',
  current_price: 'Precio actual',
  invalid_range_tip:
    'Rango seleccionado no valido. El precio minimo debe ser inferior al precio maximo.',
  maket_price_outside_single_only_tip:
    'El precio del mercado esta fuera de su rango de precios.',
  min_price: 'Precio minimo',
  max_price: 'Precio maximo',
  min: 'Minimo',
  out_of_range: 'Fuera de rango',
  in_range: 'En el rango',
  unclaimed_fees: 'Tarifas no reclamadas',
  your_position_will_be: 'tu posicion sera',
  at_this_price: 'a este precio',
  price_range: 'Rango de precios',
  positions: 'posiciones',
  position: 'Position',
  range: 'Rango',
  login_risk_tip:
    'Al marcar esta casilla y continuar, confirmas que comprendes completamente los riesgos de usar {appName}.',
  stable_pool: 'Pool Estable',
  market_rate: 'Tasa de Mercado',
  no_token_found: 'Token no encontrado',
  search_name_or_address: 'Buscar nombre o pegar dirección...',
  token_address_invalid: 'La dirección del token no es válida',
  price_impact_warning: 'Advertencia de Impacto en el Precio',
  confirm_order: 'Confirmar Orden',
  you_Sell: 'Tú Vendes',
  to_Buy: 'para Comprar',
  at_Price: 'a Precio',
  insufficient_balance: 'Saldo Insuficiente',
  limitTip:
    'Tu precio se establece automáticamente en la ranura de precio más cercana',
  v2_pools: 'Pools DCL',
  v2_your_pool_introduction: 'Tu liquidez discretizada concentrada',
  v1_your_pool_introduction: 'Tu liquidez en pools clásicos',
  estimate_value: 'Valor Estimado',
  price: 'Precio',
  '@price': '@Precio',
  trades: 'Trades',
  time: 'Tiempo',
  balances: 'Saldos',
  asset: 'Activo',
  action: 'Acción',
  market: 'Mercado',
  Maker: 'Maker',
  chart: 'Gráfico',
  refresh_data_to_continue: 'Por favor, actualiza los datos para continuar',
  refresh: 'Actualizar',
  both: 'Ambos',
  All: 'Todos',
  Filled: 'Lleno',
  assets: 'Activos',
  cancel_order: 'Cancelar Orden',
  instrument: 'Instrumento',
  dex: 'Dex',
  limit_order_created: 'Orden Límite Creada',
  limit_order_filled: 'Orden Límite Llenada',
  classic_pools: 'Pools Clásicos',
  active_orders: 'Órdenes Activas',
  your_liquidity_usd_value: 'Tu Liquidez (valor en USD)',
  usage: 'Uso',
  holding: 'Tenencia',
  your_lp_tokens_and_shares: 'Tus Tokens de LP (Shares)',
  swapped: 'Intercambiado',
  dcl_pool: 'Pool DCL',
  classic: 'Clásico',
  classic_farms: 'Farms Clásicos',
  locked_in: 'bloqueado en',
  'deposit_near_tip_0.5':
    'Para depositar, mantén al menos 0.5 NEAR para cubrir la tarifa de gas',
  trade: 'Operar',
  earn_2: 'Ganar',
  portfolio: 'Portafolio',
  more_2: 'Más',
  liquidity_pools_2: 'Pools de Liquidez',
  stable_pools: 'Pools Estables',
  pool_detail: 'Detalle del Pool',
  new_contract_deploy_tip:
    '¡Se ha implementado un nuevo contrato! Por favor, retira tu liquidez del contrato antiguo',
  remove_will_automatically_claim:
    'Al retirar, automáticamente reclamarás tus comisiones no reclamadas.',
  legacy_tip: 'Se encontraron tokens de LP no staked o recompensas en',
  legacy_farms: 'Farms Antiguos',
  all_farms: 'Todas las Farms',
  your_farms_2: 'Tus Farms',
  dcl_farms: 'Farms DCL',
  farm_type: 'Tipo de Farm',
  farm_2: 'Farm',
  to_claim: 'Reclamar',
  liquidity_staked: 'Liquidez staked',
  dcl_pool_detail: 'Detalle de Pool DCL',
  reward_range: 'Rango de Recompensa',
  reward_range_tip: 'Recompensa de Farm dentro de este rango',
  ending_soon: 'Finalizando pronto',
  farm_ended_tip: 'Esta farm ha finalizado.',
  farm_will_ended_tip: 'Esta farm finalizará pronto.',
  new_farm: 'Nueva Farm',
  is_coming: 'está llegando',
  est_apr: 'Est. APR',
  farming: 'Farm',
  unavailable: 'No disponible',
  hide: 'Ocultar',
  show: 'Mostrar',
  your: 'Tu',
  max_apr: 'Max. APR',
  you_can_earn_tip: 'Puedes ganar recompensas haciendo farming, el est. APR es',
  you_can_earn_current_tip:
    'Tu farm staked actual ha finalizado y una nueva farm está llegando, el est. APR es',
  go_new_farm: 'Ir a Nueva Farm',
  go_farm: 'Ir a Farm',
  in_ended_farm: 'en la farm finalizada',
  staked: 'Stakeado',
  in_farm_3: 'en farm',
  estimation: 'Valor Estimado',
  this_staked_tip: 'Este apostado',
  dcl_liquidity: 'Liquidez DCL',
  classic_liquidity: 'Liquidez Clásica',
  will_appear_here_tip: 'Tus posiciones de liquidez aparecerán aquí.',
  dcl_will_appear_here_tip: 'Tus posiciones de liquidez DCL aparecerán aquí.',
  classic_will_appear_here_tip:
    'Tus posiciones de liquidez Clásica aparecerán aquí.',
  price_range_overlap_ratio: 'Ratio de Superposición de Rango de Precio',
  real_time_executed_orders: 'órdenes ejecutadas en tiempo real',
  real_time_executed_orders_tip:
    'Cuando colocas una orden de venta por encima del precio de mercado o una orden de compra por debajo del precio de mercado utilizando la función de orden límite, {appName} intentará ejecutar primero una acción de intercambio con punto de parada y si queda algún monto restante, se creará una orden límite para completar el resto.<br> Las órdenes ejecutadas en tiempo real se refieren a las órdenes realizadas utilizando la función de orden límite, pero ejecutadas a través del intercambio. En la sección "Historial", puedes ver las órdenes ejecutadas en tiempo real entre la orden límite mostrada más temprana en el Historial hasta el tiempo presente.',
  swapped_history_order: 'Orden de historial de intercambio',
  ledger_guide_tip_1:
    'Para usar exitosamente tu billetera Ledger para transacciones, la ',
  ledger_guide_tip_2: 'característica se ha activado automáticamente.',
  ledger_guide_tip_3: 'Por favor ten en cuenta',
  ledger_guide_tip_quote: '"',
  support_ledger_tip_new: '"Soporte para Ledger"',
  ledger_guide_tip_4:
    'que debido a las limitaciones de la billetera Ledger, la tasa actual proporcionada por la función de intercambio',
  ledger_guide_tip_5: 'puede que no sea el mejor precio.',
  ledger_guide_tip_6: '.',
  your_trade_route: 'Tu Ruta de Operación',
  markets: 'Mercados',
  exchanges: 'Exchanges',
  output_est: 'Salida (est.)',
  new_swap_order_tip:
    'El precio es de la oferta de {appName} AMM y solo es de referencia. No hay garantía de que tu orden límite se complete de inmediato.',
  instants_swap: 'Intercambio Instantáneo',
  swappped: 'Intercambiado',
  claimed: 'Reclamado',
  executing_capital: 'Ejecutando',
  trade_route: 'Ruta de Operación',
  settings: 'Configuraciones',
  no_trade_routes: 'No hay Rutas de Operación',
  steps_in_the_route: 'Pasos en la Ruta',
  swap_chart_no_data:
    'No hay suficientes datos para el gráfico en este momento.',
  last_updated: 'Última Actualización',
  steps_in_the_route_zh: '',
  Burrow: 'Burrow',
  Supplied: 'Suministrado',
  APY: 'APY',
  top_bin_apr: 'Top Bin APR (24h)',
  size: 'Tamaño',
};
export default Object.assign(es, es_in_risks_page);
